import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';

@Component({
  selector: 'app-ok-dialog',
  template: `
    @if (resAsync | async) {
      <div>
        <div style="text-align: center; padding: 10px 22%;">
          <mat-icon style="height: 70px; width: 70px" [svgIcon]="res.svgName('Warning-Image')"></mat-icon>
          <h3 style="font-size: 25px; color: #a3c100;margin: 0 0 15px 0" [innerHTML]="this.dialogHeader"></h3>
          <p
            [innerHTML]="this.dialogText"
            class="okDialogText"
            style="font-size: 16px;  margin: 10px 0;display: flex;flex-direction: column;align-items: center; padding-left: 0px"
          ></p>
          <div style="display: flex; justify-content: center">
            <button
              mat-button
              (click)="okClick()"
              style="border: 1px solid #a3c100; color: #a3c100; padding: 5px 60px;"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OkDialogComponent implements OnInit {
  onOkClick: () => void;
  public dialogHeader: string;
  public dialogText: string;
  public resAsync: Promise<ResourceSet>;
  public res = ResourceSet.Empty;

  constructor(private resourceService: ResourceManagerService) {
    this.resAsync = this.resourceService.getResourceSet('abc-maintenance-opera');
  }

  async ngOnInit() {
    this.res = await this.resAsync;
  }

  public okClick() {
    if (this.onOkClick) {
      this.onOkClick();
    }
  }
}
